import styled from "@emotion/styled";
import { Typography, Form, Switch, Alert } from "antd";
import UploadImages from "../../UploadImages";
import { FC } from "react";
import { allowFileExtensionsImage } from "config";
import UploadImagesProduct from "../../UploadImagesProduct";

interface ProductImageCardProps {
  is_active: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
  isEditMode?: boolean; // โหมดแก้ไขสินค้า (optional)
  variants?: any[]; // ข้อมูล variants สำหรับตรวจสอบสถานะ SKU (optional)
}

const ProductImageCard: FC<ProductImageCardProps> = ({ is_active, setCheckIsActive, isEditMode = false, variants = [] }) => {
  return (
    <>
      <TextWrapper>
        <Typography.Text>รูปภาพสินค้า</Typography.Text>
        <Form.Item
        label="เปิดการขาย"
        name="is_active"
        valuePropName="checked"
        rules={[{ required: false, message: "กรุณากรอกชื่อสินค้า" }]}
        className="switch-form-item"
      >
        <Switch
          checked={is_active}
          disabled={(() => {
            // ใน Edit Mode: disabled เฉพาะเมื่อ SKU ทุกรายการเป็น inactive
            if (isEditMode && variants.length > 0) {
              const allSKUsInactive = variants.every((variant: any) => 
                variant.items.every((item: any) => item.is_active === false)
              );
              return allSKUsInactive;
            }
            // ใน Create Mode: disabled เมื่อไม่มี SKU ที่เป็น active
            if (!isEditMode && variants.length > 0) {
              const hasActiveSKU = variants.some((variant: any) => 
                variant.items.some((item: any) => item.is_active === true)
              );
              return !hasActiveSKU;
            }
            // ใน Create Mode: disabled เมื่อ is_active = false และยังไม่มี SKU
            return !is_active;
          })()}
          onChange={(value) => {
            setCheckIsActive(value);
          }}
        />
      </Form.Item>
      </TextWrapper>
      
      {/* แสดงข้อความแจ้งเตือนเมื่อ Switch ถูกปิดใช้งาน */}
      {(() => {
        // ใน Edit Mode: แสดงเมื่อ is_active = false และ SKU ทุกรายการเป็น inactive
        if (isEditMode && variants.length > 0) {
          const allSKUsInactive = variants.every((variant: any) => 
            variant.items.every((item: any) => item.is_active === false)
          );
          return !is_active && allSKUsInactive;
        }
        
        // ใน Create Mode: แสดงเมื่อมี SKU แต่ไม่มี SKU ไหนที่เป็น active
        if (!isEditMode && variants.length > 0) {
          const hasActiveSKU = variants.some((variant: any) => 
            variant.items.some((item: any) => item.is_active === true)
          );
          return !hasActiveSKU;
        }
        
        return false;
      })() && (
        <AlertWrapper>
          <Alert
            message="ระบบไม่สามารถเปิดการขายได้"
            description="เนื่องจากไม่มี SKU ใดที่มีสถานะ 'เปิดการขาย' กรุณาตั้งค่า SKU อย่างน้อย 1 รายการให้มีสถานะ 'เปิดการขาย' ในส่วน 'กำหนดราคาและลักษณะแพ็คเกจสินค้า'"
            type="warning"
            showIcon
            closable={false}
          />
        </AlertWrapper>
      )}
      
      <UploadWrapper>
        <Form.Item
          name="main_images"
          rules={[
            {
              required: is_active,
              message: "กรุณาเพิ่มรูปภาพสินค้า",
            },
          ]}
        >
          <UploadImagesProduct maximumUploadItems={10} allowFileExtensions={allowFileExtensionsImage}/>
        </Form.Item>
      </UploadWrapper>
    </>
  );
};

export default ProductImageCard;

// scroll x direction
const UploadWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 0px 0px 8px 8px;
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const AlertWrapper = styled.div`
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
`;
